import { UPDATE_FORM_KYC_FILL } from '../actions/setting';

export const formKycFillReducer = (state = false, action) => {
  switch (action.type) {
    case UPDATE_FORM_KYC_FILL:
      return action.payload;
  }
  return state;
};
